import { render, staticRenderFns } from "./tablemaintenance.vue?vue&type=template&id=71fcb338&scoped=true&"
import script from "./tablemaintenance.vue?vue&type=script&lang=js&"
export * from "./tablemaintenance.vue?vue&type=script&lang=js&"
import style0 from "./tablemaintenance.vue?vue&type=style&index=0&id=71fcb338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fcb338",
  null
  
)

export default component.exports